import { c as _c } from "react/compiler-runtime";
import { createContext, ReactNode, use, useMemo } from 'react';
import { useAccountKCI } from 'api/modules/accounts';
interface CommuterMetricsProviderProps {
  accountId: string;
  /**
   * Enable data fetching in the provider. This allows us to use
   * the provider at top level tree without being concerned to fetch
   * too many times the data when we don't need it.
   */
  enabled?: boolean;
  hasCommute?: boolean;
  children: ReactNode;
}
type CommuterMetricsContextProps = ReturnType<typeof useAccountKCI>;
export const CommuterMetricsContext = createContext<CommuterMetricsContextProps | null>(null);
function CommuterMetricsProvider(t0) {
  const $ = _c(6);
  const {
    accountId,
    hasCommute: t1,
    enabled,
    children
  } = t0;
  const hasCommute = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = Boolean(accountId && enabled && hasCommute);
  let t4;
  if ($[1] !== t3) {
    t4 = {
      enabled: t3
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const state = useAccountKCI(accountId, t2, t4);
  const value = state;
  if (!enabled) {
    return children;
  }
  let t5;
  if ($[3] !== children || $[4] !== value) {
    t5 = <CommuterMetricsContext value={value}>{children}</CommuterMetricsContext>;
    $[3] = children;
    $[4] = value;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
const useCommuterMetrics = () => {
  const context = use(CommuterMetricsContext);
  if (!context) {
    throw new Error('useCommuterMetricsContext must be used within a CommuterMetricsProvider');
  }
  return context;
};
export { CommuterMetricsProvider, useCommuterMetrics };